import React from 'react'

const NumberedList = (props) => {
    const items = props.itemArray.map((val, key) => {
        const innerItems = val.items.map((val, key) => (
            <div className="nl-item-info--inneritem" key={key}>
                {`- ${val}`}
            </div>
        ))

        return (
            <div key={key} className="nl-item">
                <div className="nl-item-number">
                    <span className="nl-item-number__text">{key + 1}</span>
                </div>
                <div className="nl-item-info">
                    <h3 className="subheader nl-item-info__title">{val.title}</h3>
                    {innerItems}
                </div>
            </div>
        )
    })

    return (
        <div>
            <p className="paragraph nl-text">{props.text}</p>
            <div className="nl-item-container">
                {items}
            </div>
        </div>
    )
}

NumberedList.defaultProps = {
    text: '',
    itemArray: [{}]
}

export default NumberedList



// WEBPACK FOOTER //
// ./src/scripts/components/NumberedList.jsx